import { createFileRoute, redirect } from '@tanstack/react-router'
import { getAccessToken } from '@/lib/api'
import { getAuthUser } from '@/lib/auth'
import { getHomeRoute } from '@/lib/roles'

/**
 * Aiguillage racine. `silentRefresh()` a déjà tourné dans main.tsx, donc
 * `getAuthUser()` est fiable ici.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const user = getAuthUser()
    if (user) throw redirect({ to: getHomeRoute(user.roles) })

    // Démarrage à froid sans réseau : le shell est servi par le service worker,
    // mais `silentRefresh()` n'a pas pu aboutir. Renvoyer vers /connexion
    // afficherait un formulaire qui échouerait à chaque envoi.
    if (!navigator.onLine && !getAccessToken()) {
      throw redirect({ to: '/hors-connexion' })
    }

    throw redirect({ to: '/connexion' })
  },
})
